import { motion, useReducedMotion, type PanInfo } from 'framer-motion';
import { useRef, useState } from 'react';
import { Trash2, Check } from 'lucide-react';
import { useCoarsePointer } from '@/hooks/use-coarse-pointer';

interface SwipeActionsProps {
  children: React.ReactNode;
  onComplete?: () => void;
  onDelete?: () => void;
}

export function SwipeActions({ children, onComplete, onDelete }: SwipeActionsProps) {
  const reduce = useReducedMotion();
  // Swipe é gesto de dedo. Com mouse o drag do framer travaria a seleção de texto do card.
  const coarse = useCoarsePointer();
  const [x, setX] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  function handleEnd(_: unknown, info: PanInfo) {
    const off = info.offset.x;
    if (off > 90 && onComplete) {
      onComplete();
    } else if (off < -90 && onDelete) {
      onDelete();
    }
    setX(0);
  }

  if (reduce || !coarse) return <div>{children}</div>;

  return (
    <div className="relative md:[&>div]:!transform-none">
      <div className="absolute inset-0 flex items-center justify-between px-4 rounded-2xl overflow-hidden">
        <div
          className="flex items-center gap-2 text-success-foreground bg-success rounded-l-2xl h-full px-4"
          style={{ opacity: x > 20 ? Math.min(1, x / 90) : 0 }}
        >
          <Check className="h-5 w-5" />
          <span className="text-sm font-semibold">Concluir</span>
        </div>
        <div
          className="flex items-center gap-2 text-destructive-foreground bg-destructive rounded-r-2xl h-full px-4"
          style={{ opacity: x < -20 ? Math.min(1, -x / 90) : 0 }}
        >
          <span className="text-sm font-semibold">Excluir</span>
          <Trash2 className="h-5 w-5" />
        </div>
      </div>
      <motion.div
        ref={ref}
        drag="x"
        dragConstraints={{ left: -160, right: 160 }}
        dragElastic={0.15}
        onDrag={(_, info) => setX(info.offset.x)}
        onDragEnd={handleEnd}
        animate={{ x: 0 }}
        className="relative"
      >
        {children}
      </motion.div>
    </div>
  );
}
